import { createAsyncThunk } from '@reduxjs/toolkit';
import estimateApi from '~/apis/estimate';
import { CREATE_PRICE, EDIT_PRICE, GET_PRICE, GET_PRICES } from '~/utils/constants/actionType';
import { IBodyCreatePrice, IParamsGetPriceComponent, IPrice, IResponseGetPriceList } from '~/utils/interface/estimate';

export const handleCreatePrice = createAsyncThunk<IBodyCreatePrice, IBodyCreatePrice>(
  CREATE_PRICE,
  async (data: IBodyCreatePrice, { rejectWithValue }) => {
    try {
      const res = await estimateApi.createPrice(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetPrices = createAsyncThunk<IResponseGetPriceList, IParamsGetPriceComponent>(
  GET_PRICES,
  async (params: IParamsGetPriceComponent = {}, { rejectWithValue }) => {
    try {
      const res = await estimateApi.getPriceList(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetPrice = createAsyncThunk<IPrice, string>(GET_PRICE, async (id: string, { rejectWithValue }) => {
  try {
    const res = await estimateApi.getPrice(id);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const handleEditPrice = createAsyncThunk<IBodyCreatePrice, { id: string; params: IBodyCreatePrice }>(
  EDIT_PRICE,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await estimateApi.updatePrice(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
